import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { Link } from "react-router-dom";

interface ATSStatsCardsProps {
  totalColleges: number;
  completed: number;
  upcoming: number;
  totalStudents: number;
  totalSelected:number;
  totalOffered: number;
  totalAccepted: number;
  totalJoined: number;
}

export function ATSStatsCards(props: ATSStatsCardsProps) {
  const cards = [
    {
      label: "Total Colleges",
      value: props.totalColleges,
      tooltip: "Total number of colleges registered in the portal.",
      link: "#college-summary"
    },
    {
      label: "Completed Colleges",
      value: props.completed,
      tooltip: "Colleges where the visit date is in the past.",
      link: "#upcoming-colleges"
    },
    {
      label: "Upcoming Colleges",
      value: props.upcoming,
      tooltip: "Colleges scheduled for a future visit.",
      link: "#upcoming-colleges"
    },
    {
      label: "Total Students",
      value: props.totalStudents,
      tooltip: "All candidates across every college.",
      link: "#stage-students"
    },
     {
      label: "Total Selected",
      value: props.totalSelected,
      tooltip: "Candidates who have been selected.",
      link: "#stage-students"
    },
    {
      label: "Total Offered",
      value: props.totalOffered,
      tooltip: "Candidates who have received an offer.",
      link: "#stage-students"
    },
    {
      label: "Total Accepted",
      value: props.totalAccepted,
      tooltip: "Candidates who accepted the offer.",
      link: "#stage-students"
    },
    {
      label: "Total Joined",
      value: props.totalJoined,
      tooltip: "Candidates who actually joined the company.",
      link: "#stage-students"
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <TooltipProvider key={card.label}>
        <Tooltip >
          <TooltipTrigger asChild>
            <Link to={card.link} className="block">
              <Card>
                <CardHeader className="pb-2">
                  <CardTitle className="text-sm font-medium">
                    {card.label}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">{card.value}</div>
                </CardContent>
              </Card>
            </Link>
          </TooltipTrigger>
          <TooltipContent>{card.tooltip}</TooltipContent>
        </Tooltip>
        </TooltipProvider>
      ))}
    </div>
  );
}
